import React from 'react';

export const Leaf = ({ attributes, children, leaf }) => {
  let styledChildren = children;

  if (leaf.bold) {
    styledChildren = <strong>{styledChildren}</strong>;
  }

  if (leaf.italic) {
    styledChildren = <em>{styledChildren}</em>;
  }

  if (leaf.underline) {
    styledChildren = <u>{styledChildren}</u>;
  }

  if (leaf.strikethrough) {
    styledChildren = <s>{styledChildren}</s>;
  }

  if (leaf.code) {
    styledChildren = <code>{styledChildren}</code>;
  }

  if (leaf.mention) {
    styledChildren = <span style={{ color: '#007bff' }}>{styledChildren}</span>;
  }

  if (leaf.hashtag) {
    styledChildren = <span style={{ color: '#28a745' }}>{styledChildren}</span>;
  }

  if (leaf.highlight) {
    styledChildren = <span style={{ backgroundColor: '#ffff00' }}>{styledChildren}</span>;
  }

  // Wrap in link last so that inner formatting is preserved
  if (leaf.link) {
    styledChildren = (
      <a
        href={leaf.link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1677ff', textDecoration: 'underline' }}
      >
        {styledChildren}
      </a>
    );
  }

  const spanStyle = {
    ...(leaf.color && { color: leaf.color }),
    ...(leaf.backgroundColor && { backgroundColor: leaf.backgroundColor }),
    ...(leaf.fontSize && { fontSize: leaf.fontSize ? leaf.fontSize + 'px' : '14px' })
  };

  console.log('spanStyle', spanStyle);

  return (
    <span {...attributes} style={spanStyle}>
      {styledChildren}
    </span>
  );
};
